import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeDisplayStatus from "./chargeDisplayStatus";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SingleChargeDetailResponse {
  /**
   * Charge Id.
   */
  id!: string;

  /**
   * License plate for vehicle.
   */
  @observable
  licensePlate!: string;

  /**
   * CountryId for vehicle.
   */
  @observable
  countryId!: string;

  /**
   * PriceListItem Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  _chargeTypeId?: string;

  @observable
  _fuelTypeId?: string;

  /**
   * Beginning date of charge validity (first second)
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date of charge validity (last second)
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  chargeDisplayStatus!: ChargeDisplayStatus;

  /**
   * Charge price.
   */
  @observable
  price!: number;

  /**
   * Confirmation e-mail address.
   */
  @observable
  emailAddress?: string;

  @observable
  vehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;
}
